import { useAppDispatch } from '../store/store'
import { setAnimating } from '../store/widgets'
import { useAnimationEvents, UseAnimationEvents } from '../hooks'
import { useWidgetContext } from './useWidgetContext'

export type UseAnimationTracker = UseAnimationEvents

export const useAnimationTracker = (): UseAnimationTracker => {
  const dispatch = useAppDispatch()
  const { widgetId } = useWidgetContext()

  return useAnimationEvents({
    onAnimationStart: () => dispatch(setAnimating(widgetId, true)),
    onAnimationEnd: () => dispatch(setAnimating(widgetId, false)),
  })
}
